import * as React from "react";
const SvgFlag = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 96 96", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M80 26V62C80 63.1046 79.1046 64 78 64H56C51.5817 64 48 60.4183 48 56H24V86C24 87.1046 23.1046 88 22 88H18C16.8954 88 16 87.1046 16 86V10C16 8.89543 16.8954 8 18 8H22C23.1046 8 24 8.89543 24 10V16H48C52.4183 16 56 19.5817 56 24H78C79.1046 24 80 24.8954 80 26Z", fill: "currentColor" }));
export default SvgFlag;
